// extracted by mini-css-extract-plugin
export default {"icon":"AdminFavMenu_icon__Qs7NY","favCont":"AdminFavMenu_favCont__DBDU5"};